import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Activity, Plus, RefreshCw } from 'lucide-react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, PageHeader, LoadingState, ErrorState, EmptyState, SecondaryButton, PrimaryButton } from '../components/customerUi';
import TransactionActivityFeed from '../components/TransactionActivityFeed';
import { buildUserActivityFeed } from '../utils/transactionActivity';
import api from '../utils/api';

export default function LiveActivity() {
  const [user, setUser] = useState(null);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const refresh = useCallback(async () => {
    setError(null);
    try {
      const [me, transactions, disputes] = await Promise.all([api.get('/auth/me'), api.get('/transactions'), api.get('/disputes')]);
      setUser(me.data);
      setEvents(buildUserActivityFeed(transactions.data || [], { user: me.data, disputes: disputes.data || [], limit: 60, activeFirst: false }).filter(event => event.timestamp));
    } catch { setError('We could not load your activity. Try again in a moment.'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); const timer = setInterval(refresh, 30000); return () => clearInterval(timer); }, [refresh]);
  return <DashboardLayout user={user}><div style={{ maxWidth: 900, margin: '0 auto' }}>
    <PageHeader eyebrow="Your recorded activity" title="Live Activity" subtitle="Payment, delivery and dispute updates from your transactions." action={<SecondaryButton onClick={refresh}><RefreshCw size={16} /> Refresh</SecondaryButton>} />
    <Card>{loading ? <LoadingState label="Loading transaction activity…" /> : error ? <ErrorState title="Activity unavailable" body={error} action={<SecondaryButton onClick={refresh}>Try again</SecondaryButton>} /> : events.length ? <TransactionActivityFeed events={events} showTransaction onOpenEvent={event => { if (event.path) navigate(event.path); }} /> : <EmptyState icon={Activity} title="Your activity starts with a transaction" body="Confirmed events will appear here as your deals progress." action={<PrimaryButton onClick={() => navigate('/transactions/new')}><Plus size={16} /> Create a transaction</PrimaryButton>} />}</Card>
  </div></DashboardLayout>;
}
